import { render, staticRenderFns } from "./VersionInvite.vue?vue&type=template&id=12d7b76f&scoped=true"
import script from "./VersionInvite.vue?vue&type=script&lang=js"
export * from "./VersionInvite.vue?vue&type=script&lang=js"
import style0 from "./VersionInvite.vue?vue&type=style&index=0&id=12d7b76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7b76f",
  null
  
)

export default component.exports